module.exports = __webpack_public_path__ + "static/img/header7.fc7a651c.jpg";